require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-latest-social-media-updates-that-affect-your-business.json") })
        }
      }, "path---tapd-in-latest-social-media-updates-that-affect-your-business");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-latest-social-media-updates-that-affect-your-business!./.cache/json/tapd-in-latest-social-media-updates-that-affect-your-business.json
// module id = 857
// module chunks = 231608221292675